import { React, useState,useEffect } from "react";
import "./landing.css";
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import image from  "./img/switch.png";
import logoutimg from "./img/logout.png";
import imagebk from  "./img/back.png";
import {CREATE_VENDOR_ACCESS_DATA,INCORPORATIONFILES,PANFILESVENDOR,ITDCFILESVENDOR,SMEFILESVENDOR,BANKFILESVENDOR,GSTFILESVENDOR,GET_SAVEDVENDORREQ,GET_CERTIFICATE_FILES,GET_PAN_FILES,GET_ITDC_FILES,EDIT_VENDOR_ACCESS_DATA,GET_SME_FILES,GET_GST_FILES,GET_BANK_FILES} from '../AppConstant'
function Landing() {
    const [selectedrequest,setSelectedrequest]= useState("");
    const [vendorcode,setVendorcode]= useState("");
    const [plant,setPlant]= useState("");
    const [purchasingorg,setPurchasingorg]= useState("");
    const [account_group,setAccount_group]= useState("");
    const [vendorname,setVendorname]= useState("");
    const [legal_entity,setLegal_entity]= useState(""); 
    const [gst_status,setGst_status] = useState(""); 
    const [country,setCountry] = useState("");
    const [pan,setPan]= useState("");
    const [address,setAddress]= useState("");
    const [natureofvendor,setNatureofvendor]= useState("");
    const [msmestatus,setMsmestatus]= useState("");
    const [msmecategory,setMsmecategory]= useState("");
    const [currency,setCurrency]= useState("");
    const [paymentterms,setPaymentterms]= useState("");
    const [tdsdetection,setTdsdetection]= useState("");
    const [domesticschema,setDomesticschema]= useState("");
    // const [statuschange,setStatuschange]= useState("");
    const [contactspoc,setContactspoc]= useState("");
    const [contactno,setContactno]= useState("");
    const [mailid,setMailid]= useState("");
    const [vendorcategory,setVendorcategory]= useState("");
    const [vendorbankname,setVendorbankname]= useState("");
    const [bankbeneficiaryname,setBankbeneficiaryname]= useState("");
    const [vendorbankaccno,setVendorbankaccno]= useState("");
    const [ifscode,setIfscode]= useState("");
    const [gst,setGst]= useState("");
    const [certificate,setCertificate]= useState("");
    const [panfile,setPanfile]= useState("");
    const [gstfile,setGstfile]= useState("");
    const [bankfile,setBankfile]= useState("");
    const [smefile,setSmefile]= useState("");
    const [ltdcfile,setLtdcfile]= useState("");
    const [activemsme,setActivemsme]= useState(true);
    const [reasonforstatuschange,setReasonforstatuschange]= useState("");
    const [vendorlist,setVendorlist]=useState([])
    const [disablefield,setDisablefield] = useState(false);
    const [purpose,setPurpose]= useState("");
    const [asset_id,setAsset_id]= useState("");
    const [selectedrpmanager,setSelectedrpmanager] = useState("");
    const [ifchecked,setIfchecked] = useState(false);
    const [selectedtext,setSelectedtext] = useState("");
    const [start,setStart] = useState(""); 
    const [end,setEnd] = useState(""); 
    const [mindateset,setMindateset] = useState("");
    const [activitymsme,setActivitymsme]= useState("");
    const [isfirsttab,setIsfirsttab]= useState(true);
    const [issecondtab,setIssecondtab]= useState(false);
    const [openincorporationpdf,setOpenincorporationpdf]=  useState(false);
    const [openpdfpan,setOpenpdfpan]=  useState(false);
    const [openpdfltdc,setOpenpdfltdc]=  useState(false);
    const [openpdfsme,setOpenpdfsme]=  useState(false);
    const [openpdfbank,setOpenpdfbank]=  useState(false);
    const [openpdfgst,setOpenpdfgst]=  useState(false);
    const [viewpdfcerificate,setViewpdfcerificate]= useState("");
    const [viewpdfpan,setViewpdfpan]= useState("");
    const [viewpdfltdc,setViewpdfltdc]= useState("");
    const [viewpdfsme,setViewpdfsme]= useState("");  
    const [viewpdfbank,setViewpdfbank]= useState(""); 
    const [viewpdfgst,setViewpdfgst]= useState("");   
    const [isverfiednew, setIsverfiednew] = useState("");
    const [isverified, setIsverified] = useState("");
    const [remarks, setRemarks] = useState("");
    const [employeeid,setEmployeeid]= useState("");
    const [createuri,setCreateuri]= useState("");
    const [comments,setComments]= useState("");
    const calltosetmindate=()=>{
        let month;
        let day;
        if((new Date().getMonth()+1)<9){
            month="0"+(new Date().getMonth()+1)
        }else{
            month= (new Date().getMonth()+1)
        }
        if( new Date().getDate()<9){
            day= "0"+new Date().getDate()
        }else{
            day= new Date().getDate()
        }
        let date = new Date().getFullYear()+'-'+month+'-'+day
       setMindateset(date)
    }
    useEffect(()=>{calltosetmindate()},[])
    const handleSubmit = (e) => {
       
        // e.preventDefault();
        // if(!purpose||!asset_id||!selectedrpmanager){
        //     alert("Please fill all the fields")
        // }else{
        //     getUserData();
            
        // }
        if(disablefield){
            if(!vendorcode){
                 alert("Please add vendor code")
            }else{
                calleditsavefn()
            }
           
        }else{
            
             if(!plant||!purchasingorg||!account_group||!vendorname||!country||!pan||!gst_status||!gst||!address||!natureofvendor||!contactspoc||!contactno||!mailid||!msmestatus||!activitymsme||!msmecategory||!vendorbankname||!bankbeneficiaryname||!vendorbankaccno||!ifscode||!currency||!paymentterms||!tdsdetection||!domesticschema||!selectedrpmanager||!comments){
                 alert("Please fill all the field")
            }else{
             createvendor();
            }
        }
       
        
        // Add your form submission logic here
        
    };


    const checkedvalnew = (e) => {
    if (e == "verified") {
      setIsverfiednew("verified");
      let text =
        "Press a button!\nEither OK or Cancel. To confirm the verified";
      if (window.confirm(text) == true) {
        setIsverified("Yes");
        text = "You pressed OK!";
      } else {
        setIsverfiednew("notverified");

        setIsverified("No");
        text = "You canceled!";
      }
    } else {
      setIsverfiednew("notverified");
      setIsverified("No");
    }
  };
    const redirectToLogin = ()=>{
        window.location.href = "/login"
    }
    
     const handleReset = () => {
        // Reset all state variables here
         setAsset_id("");
        setSelectedrpmanager("")
        setIfchecked(false)
        const Checkboxes = document.getElementById('checkboxs');
        if(Checkboxes.checked===true){
            Checkboxes.checked=false
        }
        
    };

    const calleditsavefn =()=>{

         axios.post(EDIT_VENDOR_ACCESS_DATA, {vendorcode,gst,remarks,isverfiednew})
        .then(function (response) {
          //console.log("SuccessFully updated");
          alert(response.data);
        //   callcertificatefn(response.data.id);
          handleReset();
          

        })
          .catch(function (error) {
            console.log(error);
          });
    }
    const createvendor = ()=>{
       
        // let empid=  localStorage.getItem('empid');
        // let rqdept= localStorage.getItem('dept');
        // let reason= purpose
        // let assetid= asset_id
        // let fhemailid= selectedrpmanager
        // let empemailid = localStorage.getItem('emailid');
        // let empname = localStorage.getItem('empname');
        // let fhname =selectedtext;
        // let startdate = start;
        // let enddate = end;
        let natureofrequest = selectedrequest;
        let startdate=start
        let empname = localStorage.getItem('empname');
        let empid=  localStorage.getItem('empid');
        let remarks = "Submitted"
                
        axios.post(CREATE_VENDOR_ACCESS_DATA, {natureofrequest,plant,purchasingorg,account_group,vendorname,startdate,country,pan,gst_status,gst,address,natureofvendor,contactspoc,contactno,mailid,msmestatus,activitymsme,msmecategory,vendorbankname,bankbeneficiaryname,vendorbankaccno,ifscode,currency,paymentterms,tdsdetection,domesticschema,selectedrpmanager,comments,empname,empid,remarks})
        .then(function (response) {
          //console.log("SuccessFully updated");
        alert(response.data.msg);
          callcertificatefn(response.data.id);
          handleReset();
          

        })
          .catch(function (error) {
            console.log(error);
          });

        //   axios({
        //     method: 'post',
        //     url: INCORPORATIONFILES,
        //     headers: { "Content-Type": "multipart/form-data" },
        //     data : certificate

        // }).then(response => {
        //     // alert(response.data);
            
        // })  
        // .catch(error => {
        //     console.error(error);
        // });
       
       
    }
    const callcertificatefn=(e)=>
    {

        //   axios.post(INCORPORATIONFILES, {certificate,e})
        // .then(function (response) {
        //   //console.log("SuccessFully updated");
        
        
         

        // })
        //   .catch(function (error) {
        //     console.log(error);
        //   });
        
        axios({
            method: 'post',
            url: INCORPORATIONFILES,
            headers: { "Content-Type": "multipart/form-data" },
            data :certificate

        }).then(response => {
            // alert(response.data);
            
        })  
        .catch(error => {
            console.error(error);
        });
         axios({
            method: 'post',
            url: PANFILESVENDOR,
            headers: { "Content-Type": "multipart/form-data" },
            data : panfile

        }).then(response => {
            // alert(response.data);
            
        })  
        .catch(error => {
            console.error(error);
        });
        axios({
            method: 'post',
            url: ITDCFILESVENDOR,
            headers: { "Content-Type": "multipart/form-data" },
            data : ltdcfile

        }).then(response => {
            // alert(response.data);
            
        })  
        .catch(error => {
            console.error(error);
        });
        axios({
            method: 'post',
            url: SMEFILESVENDOR,
            headers: { "Content-Type": "multipart/form-data" },
            data : smefile

        }).then(response => {
            // alert(response.data);
            
        })  
        .catch(error => {
            console.error(error);
        });
        axios({
            method: 'post',
            url: BANKFILESVENDOR,
            headers: { "Content-Type": "multipart/form-data" },
            data : bankfile

        }).then(response => {
            // alert(response.data);
            
        })  
        .catch(error => {
            console.error(error);
        });
        axios({
            method: 'post',
            url: GSTFILESVENDOR,
            headers: { "Content-Type": "multipart/form-data" },
            data : gstfile

        }).then(response => {
            // alert(response.data);
            
        })  
        .catch(error => {
            console.error(error);
        });
    }
    const redirectTodashboard = ()=>{
        window.location.href = "/landingPage"
    }

    const checkedval=(e)=>{
        if(e.currentTarget.checked===true){
            setIfchecked(true)
        }else{
            setIfchecked(false)
        }
       
    }
    const callrequestfn=(e)=>{
        setSelectedrequest(e.target.value)
    }
    const callselectedfn=(e)=>{
        setSelectedrpmanager(e.target.value)
        setSelectedtext(e.target.options[e.target.selectedIndex].innerText)
    }
    // const callinputsetfn=(e)=>{
    //     if(e.target.value.length>6){
    //         alert("Employee ID cannot exceed 6 digit")           
    //     }else{
    //         setRequestorname(e.target.value)
    //     }   
        
    // }
    const isAlpha = checkvalue => /^[a-zA-Z]*$/.test(checkvalue)
    const assetentryfn=(e)=>{
        let checkvalue =e.target.value
        if(e.target.value.length===12){
            let strRegex = new RegExp(/^[A-Za-z]+$/i);
            let result1 = strRegex.test(checkvalue);
            let strRegex2 = new RegExp(/^[0-9]+$/i);
            let result2 = strRegex2.test(checkvalue);
            if(result1 || result2===true){
                alert("Should contain alphanumeric")
            }
           
        }
        setAsset_id(e.target.value)
    }
    
    const callplantfn=(e)=>{
        setPlant(e.target.value)
    }
    const callpurchasingfn=(e)=>{
        setPurchasingorg(e.target.value)
    }
    const callaccountfn=(e)=>{
        setAccount_group(e.target.value)
    }
    const calllegafn=(e)=>{
        setLegal_entity(e.target.value)
    }
    const callgststatusfn=(e)=>{
        setGst_status(e.target.value)
    }
    const callmsmefn=(e)=>{
        if(e.target.value==="Yes"){
            setActivemsme(false)
            setMsmestatus(e.target.value)
        }else{
            setMsmestatus(e.target.value)
            setActivitymsme("")
            setActivemsme(true)
        }
       
    }
    const callmsmeactiveymemr=(e)=>{
        setActivitymsme(e.target.value)
    }
    const callmsmecatefn=(e)=>{
        setMsmecategory(e.target.value)
    }
    const callcurrencyfn=(e)=>{
        setCurrency(e.target.value)
    }
    const callpaymentfn=(e)=>{
        setPaymentterms(e.target.value)
    }
    const calltdsfn=(e)=>{
        setTdsdetection(e.target.value)
    }
    const calldomesfn=(e)=>{
        setDomesticschema(e.target.value)
    }
    const callstatusfn=(e)=>{
        setReasonforstatuschange(e.target.value)
        
    }
    const filechangefn=(file,d)=>{
        // setRawdatafile(file)
        if(file.type === "application/pdf"){
            if(file.size <= 5000000){
        const formData = new FormData();
        formData.append('type', "Certificate_incorporation");
        formData.append('ID', gst);
        formData.append('file',file)
        console.log(formData)
        setCertificate(formData)
      
        }else{
            document.getElementById(d).value = "";
            alert("Upload Size not greater than 5 MB")
        }
        }else{
        document.getElementById(d).value = "";
        alert("Please Upload only PDF format")
        }
       } 
       const filechangepanfn=(file,d)=>{
        // setRawdatafile(file)
        if(file.type === "application/pdf"){
            if(file.size <= 5000000){
        const formData = new FormData();
        formData.append('type', "Pan_docs");
        formData.append('ID', gst);
        formData.append('file',file)
        console.log(formData)
        setPanfile(formData)
        }else{
            document.getElementById(d).value = "";
            alert("Upload Size not greater than 5 MB")
        }
        }else{
        document.getElementById(d).value = "";
        alert("Please Upload only PDF format")
        }
       } 
       const filechangegstfn=(file,d)=>{
        console.log(file)
        // setRawdatafile(file)
        if(file.type === "application/pdf"){
            if(file.size <= 5000000){
                const formData = new FormData();
            formData.append('type', "Gst_docs");
            formData.append('ID', gst);
            formData.append('file',file)
            console.log(formData)
            setGstfile(formData)
            
            }else{
                document.getElementById(d).value = "";
                alert("Upload Size not greater than 5 MB")
            }
            }else{
            document.getElementById(d).value = "";
            alert("Please Upload only PDF format")
        }
       }
       const filechangebankfn=(file,d)=>{
        console.log(file)
        // setRawdatafile(file)
        if(file.type === "application/pdf"){
            if(file.size <= 5000000){
                const formData = new FormData();
            formData.append('type', "bank_docs");
            formData.append('ID', gst);
            formData.append('file',file)
            console.log(formData)
            setBankfile(formData)
            
            }else{
                document.getElementById(d).value = "";
                alert("Upload Size not greater than 5 MB")
            }
            }else{
            document.getElementById(d).value = "";
            alert("Please Upload only PDF format")
        }
       }
       const filechangesmefn=(file,d)=>{
        console.log(file)
        // setRawdatafile(file)
        if(file.type === "application/pdf"){
            if(file.size <= 5000000){
                const formData = new FormData();
            formData.append('type', "SME_docs");
            formData.append('ID', gst);
            formData.append('file',file)
            console.log(formData)
            setSmefile(formData)
            
            }else{
                document.getElementById(d).value = "";
                alert("Upload Size not greater than 5 MB")
            }
            }else{
            document.getElementById(d).value = "";
            alert("Please Upload only PDF format")
        }
       }
       const filechangeLTDCfn=(file,d)=>{
        console.log(file)
        // setRawdatafile(file)
        if(file.type === "application/pdf"){
            if(file.size <= 5000000){
                const formData = new FormData();
            formData.append('type', "LTDC_docs");
            formData.append('ID', gst);
            formData.append('file',file)
            console.log(formData)
            setLtdcfile(formData)
            // if(!file) {
            //     setDataUri('');
            //     return;
            //   }
          
            //   fileToDataUri(file)
            //     .then(dataUri => {
            //       setDataUri(dataUri)
            //     })
            }else{
                document.getElementById(d).value = "";
                alert("Upload Size not greater than 5 MB")
            }
            }else{
            document.getElementById(d).value = "";
            alert("Please Upload only PDF format")
        }
        
       }
       const enabletab=(e)=>{
        let empid=  localStorage.getItem('empid');
        
        setEmployeeid(empid)
        if(e===2){
            setIsfirsttab(false)
            setIssecondtab(true)
            callsaveddata()
        }else{           
            setIsfirsttab(true)
            setIssecondtab(false)
        }
       }

       const callsaveddata=()=>{
        axios({
            method: "get",
            url: GET_SAVEDVENDORREQ,
            withCredentials: false,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Access-Control-Allow-Origin": "*",
            },
          })
            .then((response) => {
                // setsavedvendorraw(response.data.data)
                setVendorlist(response.data.data);
            })
            .catch((error) => {
              console.error(error);
            });
    }

    const calleditfn=(e,v)=>
    {
        setIsfirsttab(true)
        setIssecondtab(false)
        setSelectedrequest("Modification")
        setPlant(v.plant)
        setPurchasingorg(v.purchasingorg)
        setAccount_group(v.account_group)
        setVendorname(v.vendorname)
        setStart(v.startdate)
        setCountry(v.country)
        setPan(v.pan)
        setGst_status(v.gst_status)
        setGst(v.gst)
        setAddress(v.address)
        setNatureofvendor(v.natureofvendor)
        setContactspoc(v.contactspoc)
        setContactno(v.contactno)
        setMailid(v.mailid)
        setMsmestatus(v.msmestatus)
        setActivitymsme(v.activitymsme)
        setMsmecategory(v.msmecategory)
        setVendorbankname(v.vendorbankname)
        setBankbeneficiaryname(v.bankbeneficiaryname)
        setVendorbankaccno(v.vendorbankaccno)
        setIfscode(v.ifscode)
        setCurrency(v.currency)
        setPaymentterms(v.paymentterms)
        setTdsdetection(v.tdsdetection)
        setDomesticschema(v.domesticschema)
        setDisablefield(true)
    }

    const downloadfiles = (ee) => {
    const hrefee = createuri;
    const link = document.createElement("a");
    link.href = hrefee;
    link.setAttribute("download" + "_" + ee + "_.pdf"); //or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
  };

    const callcerification=()=>
    {
    //    setIsloading(true);
    axios({
      method: "post",
      url: GET_CERTIFICATE_FILES,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { gst: gst },
      responseType: "blob",
    })
      .then((response) => {
        const urlss = URL.createObjectURL(response.data);
        console.log(urlss);
        setCreateuri(urlss);
        setViewpdfcerificate(urlss);

        // fileDownload(response.data, "Adhar details"+new Date() +".pdf");
        if (response.data.size === 14) {
          alert("No Data Available");
        //   setIsloading(false);
        } else {
          console.log(response.data);
          var reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onloadend = function () {
            var base64data = reader.result;
            console.log(base64data);
            setViewpdfcerificate(base64data);
            let data_split = base64data.split(",");
            let dataset =
              "data:application/pdf;base64," + data_split[1] + "#toolbar=0";
            setViewpdfcerificate(dataset);
            setOpenincorporationpdf(true);
            // setIsloading(false);
          };
        }
      })
      .catch((error) => {
        console.error(error);
      });
    }
    const callclose=()=>
    {
       
    setOpenincorporationpdf(false);
    setOpenpdfsme(false);
    setOpenpdfltdc(false);
    setOpenpdfpan(false);
    setOpenpdfbank(false);
    setOpenpdfgst(false);
    
    }

    const callsmecard=()=>
    {
        
         axios({
      method: "post",
      url: GET_SME_FILES,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { gst: gst },
      responseType: "blob",
    })
      .then((response) => {
        const urlss = URL.createObjectURL(response.data);
        console.log(urlss);
        setCreateuri(urlss);
        setViewpdfsme(urlss);

        // fileDownload(response.data, "Adhar details"+new Date() +".pdf");
        if (response.data.size === 14) {
          alert("No Data Available");
        //   setIsloading(false);
        } else {
          console.log(response.data);
          var reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onloadend = function () {
            var base64data = reader.result;
            console.log(base64data);
            setViewpdfsme(base64data);
            let data_split = base64data.split(",");
            let dataset =
              "data:application/pdf;base64," + data_split[1] + "#toolbar=0";
            setViewpdfsme(dataset);
            setOpenpdfsme(true);
            // setIsloading(false);
          };
        }
      })
      .catch((error) => {
        console.error(error);
      });
    }
    const callbankcard=()=>
    {
        
         axios({
      method: "post",
      url: GET_BANK_FILES,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { gst: gst },
      responseType: "blob",
    })
      .then((response) => {
        const urlss = URL.createObjectURL(response.data);
        console.log(urlss);
        setCreateuri(urlss);
        setViewpdfbank(urlss);

        // fileDownload(response.data, "Adhar details"+new Date() +".pdf");
        if (response.data.size === 14) {
          alert("No Data Available");
        //   setIsloading(false);
        } else {
          console.log(response.data);
          var reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onloadend = function () {
            var base64data = reader.result;
            console.log(base64data);
            setViewpdfbank(base64data);
            let data_split = base64data.split(",");
            let dataset =
              "data:application/pdf;base64," + data_split[1] + "#toolbar=0";
            setViewpdfbank(dataset);
            setOpenpdfbank(true);
            // setIsloading(false);
          };
        }
      })
      .catch((error) => {
        console.error(error);
      });
    }
    const callgstcard=()=>
    {
        
         axios({
      method: "post",
      url: GET_GST_FILES,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { gst: gst },
      responseType: "blob",
    })
      .then((response) => {
        const urlss = URL.createObjectURL(response.data);
        console.log(urlss);
        setCreateuri(urlss);
        setViewpdfgst(urlss);

        // fileDownload(response.data, "Adhar details"+new Date() +".pdf");
        if (response.data.size === 14) {
          alert("No Data Available");
        //   setIsloading(false);
        } else {
          console.log(response.data);
          var reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onloadend = function () {
            var base64data = reader.result;
            console.log(base64data);
            setViewpdfgst(base64data);
            let data_split = base64data.split(",");
            let dataset =
              "data:application/pdf;base64," + data_split[1] + "#toolbar=0";
            setViewpdfgst(dataset);
            setOpenpdfgst(true);
            // setIsloading(false);
          };
        }
      })
      .catch((error) => {
        console.error(error);
      });
    }
    const callpanfn=()=>
    {
        
         axios({
      method: "post",
      url: GET_PAN_FILES,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { gst: gst },
      responseType: "blob",
    })
      .then((response) => {
        const urlss = URL.createObjectURL(response.data);
        console.log(urlss);
        setCreateuri(urlss);
        setViewpdfpan(urlss);

        // fileDownload(response.data, "Adhar details"+new Date() +".pdf");
        if (response.data.size === 14) {
          alert("No Data Available");
        //   setIsloading(false);
        } else {
          console.log(response.data);
          var reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onloadend = function () {
            var base64data = reader.result;
            console.log(base64data);
            setViewpdfpan(base64data);
            let data_split = base64data.split(",");
            let dataset =
              "data:application/pdf;base64," + data_split[1] + "#toolbar=0";
            setViewpdfpan(dataset);
            setOpenpdfpan(true);
            // setIsloading(false);
          };
        }
      })
      .catch((error) => {
        console.error(error);
      });
    }
    const callltdccard=()=>
    {

             axios({
      method: "post",
      url: GET_ITDC_FILES,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { gst: gst },
      responseType: "blob",
    })
      .then((response) => {
        const urlss = URL.createObjectURL(response.data);
        console.log(urlss);
        setCreateuri(urlss);
        setViewpdfltdc(urlss);

        // fileDownload(response.data, "Adhar details"+new Date() +".pdf");
        if (response.data.size === 14) {
          alert("No Data Available");
        //   setIsloading(false);
        } else {
          console.log(response.data);
          var reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onloadend = function () {
            var base64data = reader.result;
            console.log(base64data);
            setViewpdfltdc(base64data);
            let data_split = base64data.split(",");
            let dataset =
              "data:application/pdf;base64," + data_split[1] + "#toolbar=0";
            setViewpdfltdc(dataset);
            setOpenpdfltdc(true);
            // setIsloading(false);
          };
        }
      })
      .catch((error) => {
        console.error(error);
      });
        
    }

    return (
        <div>
        <form>
                <div className="row">
                    {/* <div className="col-md-6">
                    <label for="firstname">
                    Emp ID
                    </label>
                    <input
                        type="number"
                        name="firstname"
                        id="firstname"
                        value={requestorname}
                        onChange={(e) =>
                            callinputsetfn(e)
                        }
                        maxlength="6"
                        placeholder="Emp ID"
                        required
                    />
                    </div> */}
                    {/* <div className="col-md-6">
                    <label for="lastname">Requestor department</label>
                    <input
                        type="text"
                        name="lastname"
                        id="lastname"
                        value={requestdept}
                        onChange={(e) =>
                            setRequestdept(e.target.value)
                        }
                        placeholder="Department"
                        required
                        maxlength="30"
                    />
                    </div> */}
                    <div className="row tabdesign_vm">
            <div className={isfirsttab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(1)}>Creation</div>  
            <div className={issecondtab?"col-md-2 tabfirst-selected":"col-md-2 notselected"} onClick={()=>enabletab(2)}>View </div> 
         
       
           
            {/* <div className="col-md-2 tabfour">View Request</div> */}
             </div> 
                    </div>
                    {isfirsttab?<>
                    <div className="row spacing">
                    <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label>Nature of request </label>
                    </div>
                    <div className="col-md-6">
                    <select
                        name="select"
                        id="select"
                        value={selectedrequest}
                        onChange={(e) =>callrequestfn(e)}
                        disabled={disablefield}
                    >
                        <option
                            value=""
                           disabled
                            selected={selectedrequest === ""}
                        >
                            Nature of request
                        </option>                        
                            <option value="Creation">Creation</option>
                            {/* <option value="Modification">Modification</option>
                            <option value="Extension">Extension</option>
                            <option value="Unblocking vendor">Unblocking vendor</option> */}
                           
                            
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}                       
                        </select>
                        </div>
                        </div>
                        </div>
                       {disablefield?
                        <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label for="firstname">
                    Vendor code
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        
                        type="text"
                        name="vendorcode"
                        id="vendircode"
                        value={vendorcode}
                        onChange={(e) =>
                            setVendorcode(e.target.value)
                        }
                        placeholder="Vendor Code"
                        required
                    />
                    </div>
                    </div>
                    </div>:''}

                    <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-4">
                    <label>Plant </label>
                    </div>
                    <div className="col-md-8">
                    <select
                        name="plant"
                        id="plant"
                        value={plant}
                        onChange={(e) =>callplantfn(e)}
                         disabled={disablefield}
                    >
                        <option
                            value=""
                            disabled
                            selected={plant === ""}
                        >
                            Plant
                        </option>                        
                        <option value="2021-EV Pilot Plant - Ennore">2021-EV Pilot Plant - Ennore</option>
                        <option value="3001-R & D Ennore:3001">3001-R & D Ennore:3001</option>
                        <option value="3005-R & D VVC">3005-R & D VVC</option>
                        <option value="5776-EMass - Chandigarh">5776-EMass - Chandigarh</option>
                        <option value="5870-Ware House">5870-Ware House</option>
                        <option value="7011-Switch Corporate">7011-Switch Corporate</option> 
                        <option value="7151-EV Hosur">7151-EV Hosur</option>
                        <option value="7650-BMTC">7650-BMTC</option>
                        <option value="7651-BMTC-Yelahank">7651-BMTC-Yelahank</option>
                        <option value="7652-BMTC-Bidadi">7652-BMTC-Bidadi</option>
                        <option value="7653-BMTC-CHANDAPU">7653-BMTC-CHANDAPU</option>
                        <option value="7654-BEST">7654-BEST</option>
                        <option value="7655-JSW">7655-JSW</option>
                        <option value="7657-COLABA">7657-COLABA</option>
                        <option value="7659-CHALO INDORE">7659-CHALO INDORE</option>
                        <option value="7660-MOBILITY VVC">7660-MOBILITY VVC</option>
                        <option value="7661-ELCV SALES">7661-ELCV SALES</option>
                        <option value="7700-e-Bus Exp Sales Yard">7700-e-Bus Exp Sales Yard</option>
                        <option value="7701-LCV Export Sale Yard">7701-LCV Export Sale Yard</option>
                           
                            
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}                       
                        </select>
                        </div>
                        </div>
                        </div>

                        </div>
                        <div className="row spacing">
                    <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label>Purchasing organization</label>
                    </div>
                    <div className="col-md-6">
                    <select
                        name="purchasing_org"
                        id="purchasing_org"
                        value={purchasingorg}
                        onChange={(e) =>callpurchasingfn(e)}
                         disabled={disablefield}
                    >
                        <option
                            value=""
                            disabled
                            selected={plant === ""}
                        >
                            Purchasing organization
                        </option>                        
                            <option value=" SWI1"> SWI1 - Production</option>
                            <option value="SWI2">SWI2 - Non Production</option>
                            <option value="SWI3">SWI3 - Operational</option>
                            <option value="SWI4">SWI4 - After Market</option>
                           
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}                       
                        </select>
                        </div>         
                        </div>
                    </div>
                    <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label>Account Group</label>
                    </div>
                    <div className="col-md-6"> 
                    <select
                        name="account_group"
                        id="account_group"
                        value={account_group}
                        onChange={(e) =>callaccountfn(e)}
                         disabled={disablefield}
                    >
                        <option
                            value=""
                            disabled
                            selected={plant === ""}
                        >
                            Account Group
                        </option>                        
                            <option value="Production"> Production</option>
                            <option value="Service">Service</option>
                            <option value="captial vendors">captial vendors</option>
                            <option value="Import">Import</option>
                           
                            
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}                       
                        </select>
                        </div>
                        </div>

                        </div>
                        <div className="col-md-4">
                    <div className="row"> 
                    <div className="col-md-6">
                    <label for="firstname">
                    Vendor Name
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="vendorname"
                        id="vendorname"
                        //  disabled={disablefield}
                        value={vendorname}
                        onChange={(e) =>
                            setVendorname(e.target.value)
                        }
                        placeholder="Vendor Code"
                        required
                    />
                    </div>
                    </div>
                    </div>
                        {/* <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                    <label>Legal entity status</label>
                    </div>
                    <div className="col-md-6">
                    <select
                        name="legal_entity"
                        id="legal_entity"
                        value={legal_entity}
                        onChange={(e) =>calllegafn(e)}
                    >
                        <option
                            value=""
                            disabled
                            selected={plant === ""}
                        >
                            Legal entity status
                        </option>                        
                            <option value="Individual"> Individual</option>
                            <option value="Partnership">Partnership</option>
                            <option value="Private">Private</option>
                           
                           
                            
                                                
                        </select>
                        </div>     
                            </div>
                            </div> */}
                    
                    </div>

                    <div className="row spacing">
                   
                    {/* <div className="col-md-4">
                    <div className="row"> 
                    <div className="col-md-6">
                    <label for="firstname">
                    Vendor Name
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="vendorname"
                        id="vendorname"
                        value={vendorname}
                        onChange={(e) =>
                            setVendorname(e.target.value)
                        }
                        placeholder="Vendor Code"
                        required
                    />
                    </div>    
                        </div>

                        </div> */}
                        
                    </div>
                    <div className="row spacing">
                    <div className="col-md-4">
                    <div className="row"> 
                    <div className="col-md-6"> <label for="lastname">Date of incorporation</label></div>
                    <div className="col-md-6"><input type="date"   onChange={(e) =>setStart(e.target.value)} id="doi" name="doi"/>
                    </div>
                        </div>
                        </div>
                    <div className="col-md-4">
                    <div className="row"> 
                    <div className="col-md-6">
                    <label for="firstname">
                    Country
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="country"
                        id="country"
                         disabled={disablefield}
                        value={country}
                        onChange={(e) =>
                            setCountry(e.target.value)
                        }
                        placeholder="Country"
                        required
                    />
                    </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="row"> 
                        <div className="col-md-6">
                    <label for="firstname">
                    PAN
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="PAN"
                        id="pan"
                        value={pan}
                         disabled={disablefield}
                        onChange={(e) =>
                            setPan(e.target.value)
                        }
                        placeholder="PAN"
                        required
                    />
                    </div>
                    </div></div>

                    
                        </div>

                        <div className="row spacing">
                        <div className="col-md-4">
                    <div className="row"> 
                    <div className="col-md-6">
                    <label>GST Status</label>
                    </div>
                    <div className="col-md-6">
                    <select
                        name="gst_status"
                        id="gst_status"
                        value={gst_status}
                         disabled={disablefield}
                        onChange={(e) =>callgststatusfn(e)}
                    >
                        <option
                            value=""
                            disabled
                            selected={plant === ""}
                        >
                            GST Status
                        </option>                        
                            <option value="Registered"> Registered</option>
                            <option value="unregistered">unregistered</option>
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}                       
                        </select>
                        </div>
                        </div>
                        </div>
                    <div className="col-md-4">
                    <div className="row"> 
                    <div className="col-md-6">
                    <label for="gst">
                    GST
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="GST"
                        id="GST"
                        value={gst}
                         disabled={disablefield}
                        onChange={(e) =>
                            setGst(e.target.value)
                        }
                        placeholder="GST"
                        required
                    />
                    </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="row"> 
                        <div className="col-md-6">
                    <label for="firstname">
                    Address
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="address"
                        id="address"
                         disabled={disablefield}
                        value={address}
                        onChange={(e) =>
                            setAddress(e.target.value)
                        }
                        placeholder="Address"
                        required
                    />
                    </div>
                            </div>
                            </div>


                            

                        </div>         




                        <div className="row spacing">
                        <div className="col-md-4">
                            <div className="row"> 
                            <div className="col-md-6">
                    <label for="natureofvendor">
                    Domain of vendor
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="natureofvendor"
                        id="natureofvendor"
                        value={natureofvendor}
                         disabled={disablefield}
                        onChange={(e) =>
                            setNatureofvendor(e.target.value)
                        }
                        placeholder="Nature of vendor"
                        required
                    />
                    </div>
                                </div>
                                </div>
                    <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label for="contactspoc">
                    Vendor SPOC
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="contactspoc"
                        id="contactspoc"
                         disabled={disablefield}
                        value={contactspoc}
                        onChange={(e) =>
                            setContactspoc(e.target.value)
                        }
                        placeholder="Nature of vendor"
                        required
                    />
                    </div>
                    </div>
                        </div>
                        <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label for="contactno">
                    Vendor  contact no.
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="contactno"
                        id="contactno"
                         disabled={disablefield}
                        value={contactno}
                        onChange={(e) =>
                            setContactno(e.target.value)
                        }
                        placeholder="Contact No"
                        required
                    />
                    </div>
                        </div>
                    </div>
                    
                        </div>
                        <div className="row spacing">
                        <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label for="Mailid">
                    Vendor  mail id. 
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="Mailid "
                        id="Mailid"
                         disabled={disablefield}
                        value={mailid}
                        onChange={(e) =>
                            setMailid(e.target.value)
                        }
                        placeholder="Mail id"
                        required
                    />
                    </div>
                        </div>
                        </div>
                    <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label>MSME status</label>
                    </div>
                    <div className="col-md-6">

                    <select
                        name="MSME_Status"
                        id="msme_status"
                        value={msmestatus}
                         disabled={disablefield}
                        onChange={(e) =>callmsmefn(e)}
                    >
                        <option
                            value=""
                            disabled
                            selected={msmestatus === ""}
                        >
                            MSME status
                        </option>                        
                            <option value="Yes"> Yes</option>
                            <option value="No">No</option>
                                                  
                        </select>
                        </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label>Major activity of the vendor (as per MSME certificate)</label>
                    </div>
                    <div className="col-md-6">

                    <select
                        name="MSME_Status"
                        id="msme_status"
                        value={activitymsme}
                        onChange={(e) =>callmsmeactiveymemr(e)}
                        disabled={activemsme}
                    >
                        <option value="" disabled selected={msmestatus === ""}></option>                        
                            <option value="Manufacturing">Manufacturing</option>
                            <option value="Service">Service</option>
                            <option value="Trading">Trading</option>
                                                  
                        </select>
                        </div>
                        </div>
                        </div>
                        
                        {/* <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label for="Vendor_category">
                    Vendor category 
                    </label>
                    </div>
                    <div className="col-md-6">

                    <input
                        type="text"
                        name="Vendor_category"
                        id="Vendor_category"
                        value={vendorcategory}
                        onChange={(e) =>
                            setVendorcategory(e.target.value)
                        }
                        placeholder="Vendor Category"
                        required
                    />
                    </div>
                    </div>     
                    </div> */}
                        </div>
                        <div className="row spacing">
                        <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label>MSME categorization</label></div>
                    <div className="col-md-6">
                    <select
                        name="MSME_cate"
                        id="MSME_cate"
                        value={msmecategory}
                        disabled={disablefield}
                        onChange={(e) =>callmsmecatefn(e)}
                    >
                        <option
                            value=""
                            disabled
                            selected={msmecategory === ""}
                        >
                            MSME categorization
                        </option>                        
                            <option value="Micro"> Micro</option>
                            <option value="Small">Small</option>
                            <option value="Medium">Medium</option>
                                                  
                        </select>
                        </div>
                        </div></div>
                    <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label for="Vendor_Bank_name">
                    Bank Name 
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="Vendor_Bank_name"
                        id="Vendor_Bank_name"
                        disabled={disablefield}
                        value={vendorbankname}
                        onChange={(e) =>
                            setVendorbankname(e.target.value)
                        }
                        placeholder="Vendor Bank name"
                        required
                    />
                    </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                    <label for="Bank_beneficiary_name">
                    Beneficiary name  
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="Bank_beneficiary_name"
                        id="Bank_beneficiary_name"
                        disabled={disablefield}
                        value={bankbeneficiaryname}
                        onChange={(e) =>
                            setBankbeneficiaryname(e.target.value)
                        }
                        placeholder="Bank Beneficiary name"
                        required
                    />
                    </div> </div></div>
                    
                        </div>
                        <div className="row spacing">
                        <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label for="vendor_bank_acc_no">
                    Account no.
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="vendor_bank_acc_no"
                        id="vendor_bank_acc_no"
                        disabled={disablefield}
                        value={vendorbankaccno}
                        onChange={(e) =>
                            setVendorbankaccno(e.target.value)
                        }
                        placeholder="Vendor Bank account no."
                        required
                    />
                    </div>
                        </div></div>
                    <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label for="IFSC_code">
                    IFSC code   
                    </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="IFSC_code"
                        id="IFSC_code"
                        value={ifscode}
                        disabled={disablefield}
                        onChange={(e) =>
                            setIfscode(e.target.value)
                        }
                        placeholder="IFSC code"
                        required
                    />
                    </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                    <label>Currency</label>
                    </div>
                    <div className="col-md-6">
                    <select
                        name="Currency"
                        id="Currency"
                        value={currency}
                        disabled={disablefield}
                        onChange={(e) =>callcurrencyfn(e)}
                    >
                        <option
                            value=""
                            disabled
                            selected={currency === ""}
                        >
                            Currency
                        </option>                        
                            <option value="INR"> INR</option>
                            <option value="USD">USD</option>
                            <option value="POUND">POUND</option>
                                                  
                        </select>
                        </div>
                            </div>
                            </div>
                           
                             
                        </div>
                        <div className="row spacing">
                        <div className="col-md-4">
                            <div className="row">
                            <div className="col-md-6">
                    <label>Payment terms</label>
                    </div>
                    <div className="col-md-6">
                    <select
                        name="payment_terms"
                        id="payment_terms"
                        value={paymentterms}
                        disabled={disablefield}
                        onChange={(e) =>callpaymentfn(e)}
                    >
                        <option
                            value=""
                            disabled
                            selected={currency === ""}
                        >
                            Currency
                        </option>                        
                            <option value="INR"> INR</option>
                            <option value="USD">USD</option>
                            <option value="POUND">POUND</option>
                                                  
                        </select>
                        </div>
                                </div></div>
                    <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label>Applicability of lower TDS deduction </label>
                    </div>
                    <div className="col-md-6">
                    <select
                        name="tds_deduction"
                        id="tds_deduction"
                        value={tdsdetection}
                        disabled={disablefield}
                        onChange={(e) =>calltdsfn(e)}
                    >
                        <option
                            value=""
                            disabled
                            selected={tdsdetection === ""}
                        >
                            Applicability of lower TDS deduction
                        </option>                        
                            <option value="Yes"> Yes</option>
                            <option value="No">No</option>
                           
                                                  
                        </select>
                        </div> 
                        </div>
                        </div>

                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                         <label>Domestic Schema</label>
                         </div>
                         <div className="col-md-6">
                    <select
                        name="domestic_schema"
                        id="domestic_schema"
                        value={domesticschema}
                        onChange={(e) =>calldomesfn(e)}
                        disabled={disablefield}
                    >
                        <option
                            value=""
                            disabled
                            selected={tdsdetection === ""}
                        >
                            Domestic Schema
                        </option>                        
                            <option value="Yes"> Yes</option>
                            <option value="No">No</option>
                           
                                                  
                        </select>
                        </div>
                            </div>
                            </div>
                            
                        </div>
                        <div className="row spacing">
                        {/* <div className="col-md-4">
                            <div className="row">
                            <div className="col-md-6">
                         <label>Status change</label>
                         </div>
                         <div className="col-md-6">
                    <select
                        name="Status_change"
                        id="Status_change"
                        value={reasonforstatuschange}
                        onChange={(e) =>callstatusfn(e)}
                    >
                        <option
                            value=""
                            disabled
                            selected={statuschange === ""}
                        >
                            Domestic Schema
                        </option>                        
                            <option value="Block"> Block</option>
                            <option value="Unblock">Unblock</option>
                           
                                                  
                        </select>
                        </div>  
                                </div></div> */}
                    {/* <div className="col-md-4">
                    <div className="row">
                    <div className="col-md-6">
                    <label for="lastname">Reason for status change </label>
                    </div>
                    <div className="col-md-6">
                    <input
                        type="text"
                        name="status_change"
                        id="status_change"
                        value={statuschange}
                        onChange={(e) =>
                            setStatuschange(e.target.value)
                        }                        
                        placeholder="Status Change"
                        required
                        
                    />
                    </div>
                        </div>
                        </div> */}
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                    <label>Select Functional Head</label></div>
                    <div className="col-md-6">
                    <select
                        name="select"
                        id="select"
                        value={selectedrpmanager}
                        onChange={(e) =>callselectedfn(e)}
                        disabled={disablefield}
                    >
                        <option
                            value=""
                            disabled
                            selected={selectedrpmanager === ""}
                        >
                            Functional Head
                        </option>                        
                            <option value="sathish.m@switchmobilityev.com">Sathish M</option>
                            <option value="jayakarthikeyan.e@switchmobilityev.com">Jayakarthikeyan EM</option>
                            <option value="dhanasekarapandian@switchmobilityev.com">DSP</option>
                            <option value="diwakar.b@switchmobilityev.com">Diwakar B</option>
                            <option value="vignesh.b@switchmobilityev.com">Vignesh.B</option>
                            
                            {/* <option value="2">CSS</option>
                            <option value="3">
                                JavaScript
                            </option> */}                       
                        </select>
                        </div>
                        </div>
                        </div>
                        </div>
                         <div className="row spacing">        
                        <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-2">
                          <label htmlFor="employeename">Purpose of onboarding</label>
                        </div>
                        <div className="col-md-6">
                          {/* <input
                            type="text"
                            name="employeename"
                            id="employeename"
                            value={comments}
                            onChange={(e) =>
                                setComments(e.target.value)
                            }
                            placeholder="Enter Comments"
                            required
                        /> */}
                          <textarea
                            id="faultreport"
                            name="faultreport"
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                            placeholder="Write your message"
                            rows="2"
                            required
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    </div>
                    {/* <div className="text-design-note">Note: Please provide a detailed justification for the access request.</div> */}
                    {!disablefield?<>
                    <div className="upload-docs">
                        <h3>Upload Documents</h3>  
                        </div>

                        <div className="row spacing">
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"> <label for="myfile">Certificate of incorporation:</label></div>
                        <div className="col-md-6"> 
                        <input type="file" id="myfiles-certifi" accept="application/pdf" onChange={(event) => filechangefn(event.target.files[0] || null,"myfiles-certifi")} name="myfiles" />
                        </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                        <label for="myfile">PAN:</label></div>
                        <div className="col-md-6">
                        <input type="file" id="myfile-pan" accept="application/pdf" onChange={(event) => filechangepanfn(event.target.files[0] || null,"myfile-pan")} name="myfile" />
                            </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label for="myfile">LTDC certificate:</label></div>
                        <div className="col-md-6"> 
                        <input type="file" id="myfile_LTDC" accept="application/pdf" onChange={(event) => filechangeLTDCfn(event.target.files[0] || null,"myfile_LTDC")} name="myfile" />
                        </div>
                        </div> 
                      
                             </div> 
                                               
                             
                        </div>

                        <div className="row spacing">
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"> <label for="myfile">GST:</label></div>
                        <div className="col-md-6"> 
                        <input type="file" id="myfile_gst" accept="application/pdf" onChange={(event) => filechangegstfn(event.target.files[0] || null,"myfile_gst")} name="myfile" />
                        </div>
                        </div>
                        </div>
                        {
                          msmestatus=="Yes" ?<div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6">
                        <label for="myfile">SME:
                        </label></div>
                        <div className="col-md-6">
                        <input type="file" id="myfile_sme"   accept="application/pdf" onChange={(event) => filechangesmefn(event.target.files[0] || null,"myfile_sme")} name="myfile" />
                            </div>
                        </div>
                        </div>:''
                        }                        
                        <div className="col-md-4">
                        <div className="row">
                        <div className="col-md-6"><label for="myfile">Bank account:</label></div>
                        <div className="col-md-6"> 
                        <input type="file" id="myfile_bank"  accept="application/pdf" onChange={(event) => filechangebankfn(event.target.files[0] || null,"myfile_bank")} name="myfile" />
                        </div>
                        </div> 
                        </div>
                        </div>
                    </>:<div>
                        
                        <div className="upload-docs">
                        <h3>View Upload Documents</h3>  
                        </div>
                         <ul>
                            <li className="list-design downloadlink" onClick={() => callcerification()}>Certificate of incorporation</li>
                                {openincorporationpdf ?
                                (<div id="myModal" className="modal-one-docs">
                                                        {/* <img
                                                          style={{
                                                            width: "2%",
                                                            cursor: "pointer",
                                                            position: "absolute",
                                                            marginLeft: "39%",
                                                            marginTop: "1%",
                                                          }}
                                                          onClick={(e) => downloadfiles("Aadhar")}
                                                          className=""
                                                          src={downloadimg}
                                                          title="download"
                                                        /> */}
                                                        <div className="closebar">
                                                          {" "}
                                                          <span
                                                            className="close-one-docs"
                                                            onClick={() => callclose()}
                                                          >
                                                            &times;
                                                          </span>
                                                        </div>
                                                        <div className="modal-content-one-docs">
                                                          <iframe
                                                            src={viewpdfcerificate}
                                                            width="100%"
                                                            height="500px"
                                                          />
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                        
                                                   
                                                    <li
                                                      className="list-design downloadlink"
                                                      onClick={() => callpanfn()}
                                                    >
                                                      PAN
                                                    </li>
                                                    {openpdfpan ? (
                                                      <div id="myModal" className="modal-one-docs">
                                                        {/* <img
                                                          style={{
                                                            width: "2%",
                                                            cursor: "pointer",
                                                            position: "absolute",
                                                            marginLeft: "39%",
                                                            marginTop: "1%",
                                                          }}
                                                          onClick={(e) => downloadfiles("NDA")}
                                                          className=""
                                                          src={downloadimg}
                                                          title="download"
                                                        /> */}
                                                        <div className="closebar">
                                                          {" "}
                                                          <span
                                                            className="close-one-docs"
                                                            onClick={() => callclose()}
                                                          >
                                                            &times;
                                                          </span>
                                                        </div>
                                                        <div className="modal-content-one-docs">
                                                          <iframe
                                                            src={viewpdfpan}
                                                            width="100%"
                                                            height="500px"
                                                          />
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                    <li
                                                      className="list-design downloadlink"
                                                      onClick={() => callltdccard()}
                                                    >
                                                      LTDC certificate
                                                    </li>
                                                    {openpdfltdc === true ? (
                                                      <div id="myModal" className="modal-one-docs">
                                                        {/* <img
                                                          style={{
                                                            width: "2%",
                                                            cursor: "pointer",
                                                            position: "absolute",
                                                            marginLeft: "39%",
                                                            marginTop: "1%",
                                                          }}
                                                          onClick={(e) => downloadfiles("Offer Letter")}
                                                          className=""
                                                          src={downloadimg}
                                                          title="download"
                                                        /> */}
                                                        <div className="closebar">
                                                          {" "}
                                                          <span
                                                            className="close-one-docs"
                                                            onClick={() => callclose()}
                                                          >
                                                            &times;
                                                          </span>
                                                        </div>
                                                        <div className="modal-content-one-docs">
                                                          <iframe
                                                            src={viewpdfltdc}
                                                            width="100%"
                                                            height="500px"
                                                          />
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                     <li
                                                      className="list-design downloadlink"
                                                      onClick={() => callgstcard()}
                                                    >
                                                      GST
                                                    </li>
                                                    {openpdfgst === true ? (
                                                      <div id="myModal" className="modal-one-docs">
                                                        {/* <img
                                                          style={{
                                                            width: "2%",
                                                            cursor: "pointer",
                                                            position: "absolute",
                                                            marginLeft: "39%",
                                                            marginTop: "1%",
                                                          }}
                                                          onClick={(e) => downloadfiles("Offer Letter")}
                                                          className=""
                                                          src={downloadimg}
                                                          title="download"
                                                        /> */}
                                                        <div className="closebar">
                                                          {" "}
                                                          <span
                                                            className="close-one-docs"
                                                            onClick={() => callclose()}
                                                          >
                                                            &times;
                                                          </span>
                                                        </div>
                                                        <div className="modal-content-one-docs">
                                                          <iframe
                                                            src={viewpdfgst}
                                                            width="100%"
                                                            height="500px"
                                                          />
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                     <li
                                                      className="list-design downloadlink"
                                                      onClick={() => callbankcard()}
                                                    >
                                                      Bank Account
                                                    </li>
                                                    {openpdfbank === true ? (
                                                      <div id="myModal" className="modal-one-docs">
                                                        {/* <img
                                                          style={{
                                                            width: "2%",
                                                            cursor: "pointer",
                                                            position: "absolute",
                                                            marginLeft: "39%",
                                                            marginTop: "1%",
                                                          }}
                                                          onClick={(e) => downloadfiles("Offer Letter")}
                                                          className=""
                                                          src={downloadimg}
                                                          title="download"
                                                        /> */}
                                                        <div className="closebar">
                                                          {" "}
                                                          <span
                                                            className="close-one-docs"
                                                            onClick={() => callclose()}
                                                          >
                                                            &times;
                                                          </span>
                                                        </div>
                                                        <div className="modal-content-one-docs">
                                                          <iframe
                                                            src={viewpdfbank}
                                                            width="100%"
                                                            height="500px"
                                                          />
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                     <li
                                                      className="list-design downloadlink"
                                                      onClick={() => callsmecard()}
                                                    >
                                                      SME
                                                    </li>
                                                    {openpdfsme === true ? (
                                                      <div id="myModal" className="modal-one-docs">
                                                        {/* <img
                                                          style={{
                                                            width: "2%",
                                                            cursor: "pointer",
                                                            position: "absolute",
                                                            marginLeft: "39%",
                                                            marginTop: "1%",
                                                          }}
                                                          onClick={(e) => downloadfiles("Offer Letter")}
                                                          className=""
                                                          src={downloadimg}
                                                          title="download"
                                                        /> */}
                                                        <div className="closebar">
                                                          {" "}
                                                          <span
                                                            className="close-one-docs"
                                                            onClick={() => callclose()}
                                                          >
                                                            &times;
                                                          </span>
                                                        </div>
                                                        <div className="modal-content-one-docs">
                                                          <iframe
                                                            src={viewpdfsme}
                                                            width="100%"
                                                            height="500px"
                                                          />
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </ul>
                        </div>}

                     {!disablefield?
                   "":<><div className="row">
                           
                            <input
                              type="radio"
                              name="verify"
                              value="verified"
                              id="verified"
                              checked={isverfiednew === "verified"}
                              onChange={(e) => checkedvalnew(e.target.value)}
                            />
                            Verified
                            <input
                              type="radio"
                              name="verify"
                              value="notverified"
                              id="notverified"
                              checked={isverfiednew === "notverified"}
                              onChange={(e) => checkedvalnew(e.target.value)}
                            />
                            Not Verified
                          </div>
                          <div className="row spacing">
                            <div className="col-md-12">
                              <div className="col-md-6">
                                <label htmlFor="lastname">Remarks</label>
                              </div>
                              <textarea
                                id="faultreport"
                                name="faultreport"
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                                placeholder="Write your message"
                                rows="4"
                                required
                              ></textarea>
                            </div>
                          </div></>}
                           <div className="row col-md-4">
                   
                    <Button
                        variant="primary"
                        className="btns"
                        type="reset"
                        value="reset"
                        onClick={() => handleReset()}
                    >
                        Clear
                    </Button>
                   
                    <Button
                    variant="primary"
                      className="btns"
                      
                        value="Submit"
                        onClick={(e) => handleSubmit(e)}
                    >
                        Submit
                    </Button>
                    
                    </div>
                          </>:<div className="table-boxs">
                <div className="row">
                        {/* <div className="col-md-1"><label htmlFor="switchcode">
                        Search
                        </label></div> */}
                        {/* <div className="col-md-3"><input
                            type="text"
                            name="switchcode"
                            id="switchcode"
                            value={searchdata}
                            onChange={(e) =>
                                searchfunction(e.target.value)
                            }
                            placeholder="Search"
                            required
                        /></div> */}
                        {/* <div className="col-md-1">
                            <Button variant="info" 
                            onClick={() => generatereport()}
                        >
                            <img style={{width: "80%",cursor: "pointer",filter:"invert(1)"}} className="" src={downloadimgbk} title="download"/> 
                        </Button> 
                        </div> */}
                        </div>
                <table className="table-full mt-3">
              <thead className="header-asset">
                <tr>
                  <th>Sl.No</th>
                  <th>Nature of Request</th>
                  <th>Plant</th>                              
                  <th>Purchasing organization</th>
                  {/* <th>DOJ</th> */}
                  <th>Account Group</th>
                  <th>Vendor Name</th>
                  {/* <th>Sub Department</th> */}
                  <th>Date of incorporation</th>
                    <th>Request Date</th>
                  {/* <th>Manager Employee ID</th> */}
                  {/* <th>Contractor Name</th>
                  <th>Vendor Code</th> */}
                  {/* <th>Verified</th>
                  <th>Status</th>
                  <th>Remarks</th> */}
                  <th>Status</th>
                  {employeeid=== '300381' ?<th>Action</th>:''}                  
                </tr>
              </thead>
              <tbody>
              {vendorlist.length?vendorlist.map((val, i) => {
                      return (
                        <tr>
                           
                          <td>{i+1}</td>
                          <td>{val.natureofrequest}</td>
                          <td>{val.plant}</td>
                          <td>{val.purchasingorg}</td>
                          {/* <td>{val.doj}</td>  */}
                          <td>{val.account_group}</td> 
                          <td>{val.vendorname}</td> 
                          {/* <td>{val.sub_department}</td>  */}
                          <td>{val.startdate}</td> 
                          {/* <td>{val.manager_id}</td>  */}
                          {/* <td>{val.contractor_name}</td> 
                          <td>{val.vendor_code}</td>  
                          <td>{val.verified}</td>
                          <td>{val.status} </td> 
                          <td>{val.remarks}</td>*/}
                          <td>{val.created_timestamp}</td> 
                            {/* <td style={{width:"15%"}}><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>mailsent(val)} className="" src={sentmail} title="Sent Mail"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>edituser(val)} className="" src={edit} title="Edit"/><img style={{width:"31%", cursor:"pointer"}} onClick={(e)=>removeuser(val)} className="" src={remove} title="Remove"/></td> */}
                            <td>{val.remarks}</td>
                          {employeeid=== '300381' || employeeid=== '300397' || employeeid=== '300649' ?<td style={{cursor:"pointer"}}onClick={(e)=>calleditfn(e,val)}>View</td>
                          :''}
                        </tr>
                      );
                    })
                  : ""}
              
              </tbody>
            </table></div>}
                </form>
                
                </div>
        // <div className="bg_set_usb">   
        //  <div className="switch" >
        //             <img className="switch-back" onClick={redirectTodashboard} src={imagebk}/>
        //             <img className="switch-img" src={image}/>
        //             <img className="logout-img" title="Logout" onClick={redirectToLogin} src={logoutimg}/>
        //         </div><br/><br/>         
        //      <div>
        //     </div>
        //     <div>
        // <div className="Apps ">
        //     <p className="Headings">VPN Requisition</p>
        //     <fieldset>
                
        //     </fieldset>
        // </div> 
        //     </div>
        
        // </div>
    );
}


export default Landing;
